export default __webpack_public_path__ + "static/media/blurredBlue.0a9239dc.png";